module.exports = __webpack_public_path__ + "img/4.590189b8.png";